import toast from "react-hot-toast"
import { AGENCY_PUBLIC_MEDIA_KIT_UPDATE_MUTATION } from "~/api/agencyPublicMediaKit"
import { useSafeMutation } from "~/common/useSafeMutation"
import { displayErrors } from "~/common/validations"

export type PublicMediaKitUpdateResult =
  | { ok: false }
  | { ok: true; publiclyViewable: boolean }

// Publishes or unpublishes an agency's public roster and media kits (ZAN-902).
// The mutation returns the agency's id and publication fields, so Apollo's
// cache updates every screen that shows them. Failures are shown to the user
// here; callers announce success, because what they say depends on where the
// change was made.
export const usePublicMediaKitUpdate = () => {
  const [runUpdate, { loading }] = useSafeMutation(
    AGENCY_PUBLIC_MEDIA_KIT_UPDATE_MUTATION
  )

  const setPublished = async (
    agencyId: string,
    enabled: boolean
  ): Promise<PublicMediaKitUpdateResult> => {
    const result = await runUpdate({
      variables: { input: { agencyId, enabled } },
    })

    const agency = result.data?.agencyPublicMediaKitUpdate.agency
    if (result.errors || !agency) {
      displayErrors(result.errors)
      if (!result.errors) toast.error("Something went wrong. Please try again.")
      return { ok: false }
    }

    return { ok: true, publiclyViewable: agency.publiclyViewable }
  }

  return { setPublished, loading }
}
